import React from 'react';
import { Box, Button, Heading, Link, Paragraph, styled } from 'bumbag';
import { Link as RouterLink } from 'react-router-dom';

import healthFundCardPlaceholder from 'legacy/images/health-fund-card-placeholder.svg';
import healthFund from 'legacy/images/small-health-fund-card-placeholder.svg';

import ConditionalWrap from '../../common/ConditionalWrap.tsx';
const SmallImage = styled.img`
  width: 56px;
  margin-top: -9px;
  margin-bottom: -8px;
`;
type Props = {
  buttonProps?: Record<string, any> | null | undefined;
  className?: string | null | undefined;
  isSmallImage?: boolean;
};
export default class AddHealthFundAccount extends React.Component<Props> {
  static defaultProps = {
    buttonProps: null,
    className: null,
    isSmallImage: false,
  };
  render = () => {
    const { buttonProps, className, isSmallImage } = this.props;
    return (
      // @ts-expect-error TS(2322): Type 'string | null | undefined' is not assignable... Remove this comment to see the full error message
      <Box className={className}>
        <Heading use="h6" fontWeight="semibold">
          Add your health fund
        </Heading>
        <Paragraph>Add your health fund details to instantly process any benefits owing to you.</Paragraph>
        <Box display="flex" justifyContent="center">
          {isSmallImage && <SmallImage src={healthFund} alt="Health fund" />}
          {!isSmallImage && <img src={healthFundCardPlaceholder} alt="Health fund" />}
        </Box>
        <ConditionalWrap
          condition={!buttonProps}
          wrap={children => (
            // @ts-expect-error
            <Link use={RouterLink} to="/account/create-health-fund-account/" textDecoration="none">
              {children}
            </Link>
          )}
        >
          <Button palette="secondary" marginTop="major-2" width="100%" {...buttonProps}>
            ADD HEALTH FUND
          </Button>
        </ConditionalWrap>
      </Box>
    );
  };
}
